import styled from "styled-components"

export const RoundImage = styled.img`
  border-radius: 100%;
  border: 2px solid #ececec;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  display: inline-block;
`
